import { useEffect, useState } from "react";
import { getMotionSlides } from "../contentfulService";

type Slide = {
    id: string;
    imageUrl: string;
};

export default function MasonryGallery() {
    const [slides, setSlides] = useState<Slide[]>([]);

    useEffect(() => {
        getMotionSlides().then(setSlides);
    }, []);

    if (!slides.length) return null;

    return (
        <section id="gallery" className="w-full  bg-[--color-bg-main] px-4 md:px-8 py-24">
            <h2 className="font-serif text-4xl tracking-tight text-textPrimary mb-6 text-center pb-14">
                Einblicke aus Uganda
            </h2>
            <div
                className="
          columns-2
          md:columns-3
          lg:columns-4
          gap-6
        "
            >
                {slides.map((slide) => (
                    <div
                        key={slide.id}
                        className="mb-6 break-inside-avoid"
                    >
                        <img
                            src={slide.imageUrl}
                            alt=""
                            className="
                w-full
                rounded-none
                md:rounded-sm
                object-cover
                transition-transform
                duration-300
                hover:scale-[1.02]
              "
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
